/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum LogicStepType {
  Condition = 'Condition',
  Action = 'Action',
  Control = 'Control'
}
